/**
 * User types
 */

export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export const UserStatusLabels: Record<UserStatus, string> = {
  [UserStatus.ACTIVE]: "Ativo",
  [UserStatus.INACTIVE]: "Inativo",
};

export enum UserRole {
  ADMIN = "ADMIN",
  SUPER = "SUPER",
  MANAGER = "MANAGER",  
  LAWYER = "LAWYER",
}

export const UserRoleLabels: Record<UserRole, string> = {
  [UserRole.ADMIN]: "Administrador",
  [UserRole.MANAGER]: "Gerente",
  [UserRole.LAWYER]: "Advogado",
};

export interface UserOutputDTO {
  _id?: string;
  name?: string;
  email?: string;
  password?: string;
  status?: string;
  role?: string;
  phases?: string[];
  enterpriseId?: string;
  city?:string,
  image?: string;
  photoUrl?: string;

        cpf_cnpj?:string,
        neighborhood?:string,
        number?:string,
        postal?:string,
        sector?:string,
        area?:string,

        state?:string,
        street?:string
        whatsapp?:string
  createdAt?: Date;
  updatedAt?: Date;
} 